jQuery(document).ready(function ($) {
		

	$(function(){
	  $('.heritage-ac-head1').click(function(){
		$(this).toggleClass('heritage-ac-head-closed');
	    $(this).next('.heritage-ac-body1').slideToggle(10);
	  });
	
	  $('.heritage-ac-close1').click(function () {
	    $(this).parents('.heritage-ac-body1').slideUp(10);
		let ostTop = $('.heritage-ac').offset().top;
        $('html,body').animate({scrollTop: ostTop}, 500);
		$('.heritage-ac-head1').toggleClass('heritage-ac-head-closed');
	  });
	});
	
	$(function(){
	  $('.heritage-ac-head2').click(function(){
		$(this).toggleClass('heritage-ac-head-closed');
	    $(this).next('.heritage-ac-body2').slideToggle(10);
	  });
	$('.heritage-ac-close2').click(function () {
	    $(this).parents('.heritage-ac-body2').slideUp(10);
		let ostTop = $('.heritage-ac').offset().top;
        $('html,body').animate({scrollTop: ostTop}, 500);
		$('.heritage-ac-head2').toggleClass('heritage-ac-head-closed');
	  });
	});
    
	
	$(function () {
        $('.more').click(function () {
            $(this).fadeOut();
            $(this).parent().removeClass("hide");
        });
        $('.heritage-content-closebtn').click(function () {
            $(this).parent().toggleClass("hide");
            $(this).next('.more').fadeIn();
        });
    });

	$('.more-btn-pc').on('click',function(){
		$(this).toggleClass('closed');
		$(this).prev('div.content-wrap').toggleClass('unlimited');
		$(this).parents('.js-u-carousel-kv-single').toggleClass('filtered');
		if($(this).hasClass('closed')){
			$(this).text('× 閉じる');
		}else{
			$(this).text('＋ 続きを読む');
		}
	})
		
	$('.js-product-galleryslick02').slick({
    dots: false,
    speed: 400,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 2000,
      settings: 'unslick'
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10%'
      }
    }],
    prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
    nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
  });
  $('.js-gallery').slick({
    dots: false,
    infinite: false,
    centerMode: true,
    centerPadding: "25%",
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        centerPadding: 0,
        infinite: true
      }
    }],
    prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
    nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
  });
  
  $(function(){
	  $("#bg-movie").YTPlayer();
	});
	
	$(function(){
	  $("#bg-sp-movie").YTPlayer();
	});	
		
});


